import { useWindowSize } from "@trussle/external-components";
import { useEffect, useState } from "react";
import { DESKTOP_VIEWPORT_WIDTH } from "../constants";

export const useIsMobile = (customWidth?: number) => {
  const { width } = useWindowSize();
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    setIsMobile(Boolean(width && width <= (customWidth || DESKTOP_VIEWPORT_WIDTH)));
  }, [width]);

  return isMobile;
};
